import { providersService } from '../services';

export const Sector = async () => {
  const { data } = await providersService.getSectorEcm();
  return data;
};
